/**
 * Returns the last part of a UID (the segment after the last hyphen)
 * @param uid - The full UID string (e.g., "14f48d58-f68e-4171-8d5c-9ddd57ce627c")
 * @returns The last segment of the UID (e.g., "9ddd57ce627c")
 */
export const getLastPartOfUid = (uid: string): string => {
  if (!uid) {
    return "";
  }

  const parts = uid.split("-");
  return parts[parts.length - 1];
};
